import { EncodingError } from '../errors/index.js';
import { RestrictionType } from '../model/index.js';
export class SemanticPreEncoder {
    static processor = [
        (tcModel) => tcModel,
        (tcModel, gvl) => {
            /**
 *
 *
 */
            tcModel.publisherRestrictions.gvl = gvl;
            /**
 *
 *
 */
            tcModel.purposeLegitimateInterests.unset([1, 3, 4, 5, 6]);
            /**
 *
 *
 *
 */
            const vectorToIntMap = new Map();
            vectorToIntMap.set('legIntPurposes', tcModel.vendorLegitimateInterests);
            vectorToIntMap.set('purposes', tcModel.vendorConsents);
            vectorToIntMap.forEach((vector, gvlVendorKey) => {
                vector.forEach((value, vendorId) => {
                    if (value) {
                        const vendor = gvl.vendors[vendorId];
                        if (!vendor || vendor.deletedDate) {
                            /**
 *
 *
 */
                            vector.unset(vendorId);
                        }
                        else if (vendor[gvlVendorKey].length === 0) {
                            if (gvlVendorKey === 'legIntPurposes' && vendor['purposes'].length === 0 && vendor['legIntPurposes'].length === 0 && vendor['specialPurposes'].length > 0) {
                                /**
 *
 *
 *
 */
                                vector.set(vendorId);
                            }
                            else if (gvlVendorKey === 'legIntPurposes' && vendor['purposes'].length > 0 && vendor['legIntPurposes'].length === 0 && vendor['specialPurposes'].length > 0) {
                                /**
 *
 *
 *
 */
                                vector.set(vendorId);
                            }
                            else {
                                /**
 *
 *
 *
 */
                                if (tcModel.isServiceSpecific) {
                                    if (vendor.flexiblePurposes.length === 0) {
                                        /**
 *
 *
 */
                                        vector.unset(vendorId);
                                    }
                                    else {
                                        /**
 *
 *
 *
 */
                                        const restrictions = tcModel.publisherRestrictions.getRestrictions(vendorId);
                                        let isValid = false;
                                        for (let i = 0, len = restrictions.length; i < len && !isValid; i++) {
                                            /**
 *
 *
 *
 *
 *
 *
 */
                                            isValid = ((restrictions[i].restrictionType === RestrictionType.REQUIRE_CONSENT &&
                                                gvlVendorKey === 'purposes') ||
                                                (restrictions[i].restrictionType === RestrictionType.REQUIRE_LI &&
                                                    gvlVendorKey === 'legIntPurposes'));
                                        }
                                        if (!isValid) {
                                            /**
 *
 *
 *
 *
 */
                                            vector.unset(vendorId);
                                        }
                                    }
                                }
                                else {
                                    /**
 *
 *
 *
 */
                                    vector.unset(vendorId);
                                }
                            }
                        }
                    }
                });
            });
            tcModel.vendorsDisclosed.set(gvl.vendors);
            return tcModel;
        },
    ];
    static process(tcModel, options) {
        const gvl = tcModel.gvl;
        if (!gvl) {
            throw new EncodingError('Unable to encode TCModel without a GVL');
        }
        if (!gvl.isReady) {
            throw new EncodingError('Unable to encode TCModel tcModel.gvl.readyPromise is not resolved');
        }
        tcModel = tcModel.clone();
        tcModel.consentLanguage = gvl.language.slice(0, 2).toUpperCase();
        if (options?.version > 0 && options?.version <= this.processor.length) {
            tcModel.version = options.version;
        }
        else {
            /**
 *
 */
            tcModel.version = this.processor.length;
        }
        const processorFunctionIndex = tcModel.version - 1;
        if (!this.processor[processorFunctionIndex]) {
            throw new EncodingError(`Invalid version: ${tcModel.version}`);
        }
        return this.processor[processorFunctionIndex](tcModel, gvl);
    }
}
